module.exports = __webpack_public_path__ + "static/img/prog.610d7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/prog.png
// module id = gVSx
// module chunks = 10